// extracted by mini-css-extract-plugin
module.exports = {"button":"NextArrowButton_button__3PPBc"};